module.exports = __webpack_public_path__ + "static/media/accessories1.4f01b4b1.jpg";